import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const Spinner = (): JSX.Element => {
  return (
    <Box
      component={CircularProgress}
      sx={{
        color: 'rgb(208, 2, 91)',
      }}
    />
  );
};

export default Spinner;
